__turbopack_context__.v({
  "backdrop": "LeaderboardBackground-module-scss-module__jHNCBG__backdrop",
  "content": "LeaderboardBackground-module-scss-module__jHNCBG__content",
  "hero": "LeaderboardBackground-module-scss-module__jHNCBG__hero",
  "horizontals": "LeaderboardBackground-module-scss-module__jHNCBG__horizontals",
  "light": "LeaderboardBackground-module-scss-module__jHNCBG__light",
  "podium": "LeaderboardBackground-module-scss-module__jHNCBG__podium",
  "rays": "LeaderboardBackground-module-scss-module__jHNCBG__rays",
  "stage1440": "LeaderboardBackground-module-scss-module__jHNCBG__stage1440",
  "stage390": "LeaderboardBackground-module-scss-module__jHNCBG__stage390",
  "stage960": "LeaderboardBackground-module-scss-module__jHNCBG__stage960",
  "title": "LeaderboardBackground-module-scss-module__jHNCBG__title",
  "topPattern": "LeaderboardBackground-module-scss-module__jHNCBG__topPattern",
  "vignette": "LeaderboardBackground-module-scss-module__jHNCBG__vignette",
});
